import axios from 'axios';

export default axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL
});


// --------------------Notes By Sucheta Singha-----------------------
// Before running this application or make any build remove .env file and build folder
//For Run
    //staging: 
    // 1. nvm use v16 (ENTER) 
    // 2. npm run start:dev  (ENTER) ,  

    //production: 
    // 1. nvm use v16 (ENTER) 
    // 2. npm run start:prod (ENTER) 

//For Build
    //staging:
    // 1. nvm use v16 (ENTER) 
    // 2. npm run build:dev  (ENTER) , 
    // 3. change version  in ApiURL.js 

    // production: 
    // 1. nvm use v16 (ENTER) 
    // 2. npm run build:prod (ENTER), 
    // 3. change version and webMode in ApiURL.js  , 
    // 4.If you Need to off any particular menu, then comment line in MasteData.js ->arrMenuDetails (OPTIONAL)
    // 5. Update Excel Sheet
    

//For https setup add .env.development, .env.production., config.js.
// change script in package.json, run npm i env-cmd cross-env --force, Change baseURl in API.js, socket.js, add scripts in package.json
